<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-box-plot`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 10h-4v28h4V10zm16 0H22v28h12V10zM6 40.718c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134H3.282c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.163-.134-.324-.134-.77V7.282c0-.446.046-.607.134-.77a.909.909 0 01.378-.378c.163-.088.324-.134.77-.134h1.436c.446 0 .607.046.77.134a.906.906 0 01.378.378c.088.163.134.324.134.77V22h4V8.564c0-.892.093-1.215.267-1.54a1.81 1.81 0 01.756-.757c.326-.174.65-.267 1.54-.267h22.873c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54V22h4V7.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.163-.088.324-.134.77-.134h1.436c.446 0 .607.046.77.134a.906.906 0 01.378.378c.088.163.134.324.134.77v33.436c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.163-.134-.324-.134-.77V26h-4v13.436c0 .892-.093 1.215-.267 1.54a1.81 1.81 0 01-.756.757c-.326.174-.65.267-1.54.267H12.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 01-.757-.756c-.174-.326-.267-.65-.267-1.54V26H6v14.718z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconBoxPlot',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
